export class Tenant {
  public static Id: string = '4093f544-baa7-4ce4-9418-55024748f4b6';
  public static Name: string = 'NewHireWeb';
  public static Header: string = 'Tenant';
}

export class ContributionConstants {
  static ContributionPercentageErrorMessage: string = 'Set Employee Contribution Based On';
  static ContributionDollarErrorMessage: string = 'Select one of the Flat Monthly Amount Paid By options.';
  static EmployeeContributionTittle: string = 'Set Employee Contribution';
  static EmployerContributionTittle: string = 'Set Employer Contribution';
  static DependentContributionTittle: string = 'Set Dependent Contribution';
  static SelectPlan: string = 'Select a plan to base the contribution on';
  static SelectPlanOnCancel: string = 'Previously selected plan(s) did not cover all employees. Please select a plan that all employees are eligible for.';
  static EmployeeContributionPerErrorMessage = "At least 50% Required";
  static DependentContributionPerErrorMessage = "At least 0% Required";
  static EmployeeContributionFlatErrorMessage = "At least $80 Required";
  static EmployeeContributionTotalAmount = 'Amount cannot be greater than plan premium';
}

export class PlanConstants {
  static carrierIdUsingGroupEffectiveDateCalculation = [6, 9, 10, 21, 11]; //carrier Id taken FROM [GAPlan].[dbo].[Carrier]
  static Benefits: string = `P001,P002,P003,P004,P005,P006,P007,P008,P014,P015,P016,P017,P020,P022,P023`;
  static CarrierSelected = "CarrierSelected";
}

export class OosConstants {
  static oosInstructionalText = 'Please select plans for the following New Hire(s) who are not covered by the plans selected. If you have any questions, please contact your Inside Sales Consultant at 800-869-6989.';
}

export class ValidationMessage {
  static SelectPackageNoPackageCoversAllMembers = 'There is no package in this carrier that covers all members. Please review your carrier selection and try again.';
  static SelectPackageSelectedPackageNotCoversAllMembers = 'Selected package does not cover all members. Please select another package.';
  static noPackagesAvailableMsg = 'No packages available. Please review your carrier selection and try again.';
  static ServerError = `A system error has occurred, please try again. If the problem persists please contact the Help Desk. `;
  static AccessDeniedError = `Unauthorized access denied or user session expired.`;
  static IdleSession = `Your session is idle. You'll be redirected back to WBQuote in few seconds.`;
}

export class ValidationDisplayPosition {
  static ContributionTop = 'ContributionTop';
  static DeliveryTop = 'DeliveryTop';
  static ContributionPlanList = 'ContributionPlanList';
  static ContributionCancelOOSPlanList = 'ContributionCancelOOSPlanList';
  static ContributionOosPlanList = 'ContributionOosPlanList';
  static ContributionEmployeePercentageBasedOn = 'ContributionEmployeePercentageBasedOn';
  static ContributionDollarAmountOption = 'ContributionDollarAmountOption';
  static ContributionEmployeeSlider = 'ContributionEmployeeSlider';
  static ContributionDependantSlider = 'ContributionDependantSlider';
}

export class LoaderConstants {
  static GroupNewHire = 'GroupNewHire';
  static SicCodeSearch = 'SicCodeSearch';
  static ZipCodeSearch = 'ZipCodeSearch';
  static GroupSearch = 'GroupSearch';
  static GroupDetailsNext = 'GroupDetailsNext';
  static ContributionLoad = 'ContributionLoad';
  static DeliveryLoad = 'DeliveryLoad';
  static EffectiveDate = 'EffectiveDate';
  static PlansPackage = 'PlansPackage';
  static Carriers = 'Carriers';
  static DashboardWorksheet = 'DashboardWorksheet';
}

export class DeliveryConstants {
  static percentageContribution = 'Percentage Contribution';
  static flatDollarContribution = 'Flat Dollar Contribution';
  static noContribution = 'No Contribution';
}

export class Constants {
  static semiColon = ';';
  static comma = ',';
  static backSlash = '/';
}

export class QuoteStatusConstants {
  static Final = "WABS"//carrier Id taken FROM [GAPlan].[dbo].[Carrier]
  static Sold = "Sold"
  static Completed = "Completed"
}

export interface ClientObject {
  clients: string[]
  value: number
}

export class Client {
  public static ClientsArray: string = `[
    { "clients": ["localhost"], "value": 1},
    { "clients": ["newhire.dev.wordandbrown.com","quote.dev.wordandbrown.com"], "value": 2},
    { "clients": ["newhire.test.wordandbrown.com","quote.test.wordandbrown.com"], "value": 3},
    { "clients": ["newhire.stage.wordandbrown.com","quote.stage.wordandbrown.com"], "value": 4},
    { "clients": ["newhire.wordandbrown.com","quote.wordandbrown.com"], "value": 5}
 
]`;
  static ClientId: string = 'nhws_client';
  static ClientScopes: string = 'openid profile email read write NewHire_Api Quote_Lite_Api Plan_Lite_Api Census_Lite_Api Broker_Lite_Api QuoteAPI Document_Manager_Api';
}
